
import { FC } from "react";
import { format, parse } from "date-fns";
import { PatientInformationProps } from "./types";
import { formatPhoneNumber, formatSSN } from "src/helpers";
import InfoRow from "src/components/infoRow";
import { PatientAttributes } from "src/pages/addCase/types";

const ShowPatientInformation: FC<PatientInformationProps> = ({ getValues }) => {
    const { prescription_attributes } = getValues();
    const patient_attributes = getValues("patient_attributes") as PatientAttributes;
    const { address } = patient_attributes;

    // const [is_us_citizen, update_is_us_citizen] = useState<boolean>()

    // useEffect(() => {
    //     if (patient_attributes) {
    //         const is_us_citizen = patient_attributes.is_us_citizen;
    //         if (is_us_citizen) {
    //             if (is_us_citizen) update_is_us_citizen(true)
    //             else update_is_us_citizen(false)
    //         }
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [patient_attributes.is_us_citizen]);


    const dobFormatted = patient_attributes?.dob
        ? format(parse(patient_attributes.dob, "yyyy-MM-dd", new Date()), "MM/dd/yyyy")
        : null;


    const getPrimaryPhone = (phoneNumbers?: { phone_type: string; number: string }[]) => {
        if (!phoneNumbers || phoneNumbers.length === 0) return null;

        // Try to find a cell phone first
        const cellPhone = phoneNumbers.find(p => p.phone_type === "cell");
        if (cellPhone) return formatPhoneNumber(cellPhone.number);

        // Otherwise, return the first available number
        return phoneNumbers[0]?.number ? formatPhoneNumber(phoneNumbers[0].number) : null;
    };

    const getPrimaryPhoneType = (phoneNumbers?: { phone_type: string; number: string }[]) => {
        if (!phoneNumbers || phoneNumbers.length === 0) return null;

        const cellPhone = phoneNumbers.find(p => p.phone_type === "cell");
        if (cellPhone) return "Cell"; // Always show as "Cell"

        return phoneNumbers[0]?.phone_type
            ? phoneNumbers[0].phone_type.charAt(0).toUpperCase() + phoneNumbers[0].phone_type.slice(1) // Capitalize first letter
            : null;
    };


    return (
        <div className="card">
            <div className={`card-header ${prescription_attributes.drug_name === 'iovera°' ? 'iovera-theme' : 'zilretta-theme'}`}>
                <h4 className="m-0">Patient Information</h4>
            </div>

            <div className="card-body">
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className="col-12">
                            <InfoRow label="Title" value={patient_attributes?.title} />
                        </div>
                        <div className="col-12">
                            <InfoRow label="First Name" value={patient_attributes?.firstname} />
                        </div>
                        <div className="col-12">
                            <InfoRow label="Last Name" value={patient_attributes?.lastname} />
                        </div>
                        <div className="col-12">
                            <InfoRow label="Middle name" value={patient_attributes?.middlename} />
                        </div>
                        <div className="col-12">
                            <InfoRow label="Date of Birth" value={dobFormatted} />
                        </div>
                        <div className="col-12">
                            <InfoRow label="Gender" value={patient_attributes?.gender} />
                        </div>
                        <div className="col-12">
                            <InfoRow label="SSN" value={patient_attributes?.ssn ? formatSSN(patient_attributes.ssn) : null} />
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="col-12">
                            <InfoRow label="Street" value={address.street} />
                        </div>
                        <div className="col-12">
                            <InfoRow label="Suite" value={address.suite} />
                        </div>
                        <div className="col-12">
                            <InfoRow label="City" value={address.city} />
                        </div>
                        <div className="col-12">
                            <InfoRow label="State" value={address?.state} />
                        </div>
                        <div className="col-12">
                            <InfoRow label="Zip" value={address?.zip} />
                        </div>
                        <div className="col-12">
                            <InfoRow label="Phone Number" value={getPrimaryPhone(patient_attributes?.phone_numbers) || "N/A"} />
                        </div>
                        <div className="col-12">
                            <InfoRow label="Type" value={getPrimaryPhoneType(patient_attributes?.phone_numbers) || "N/A"} />
                        </div>
                    </div>
                    {prescription_attributes.drug_name === "zilretta" &&
                        <div className="row">

                            <div className="row mb-3">
                                <div className="col-12 px-3">
                                    <span className="fw-bold">US citizen or permanent resident?{' '}:</span>
                                    <span className="ps-2">
                                        {
                                            typeof patient_attributes.is_us_citizen === "boolean" ?
                                                (patient_attributes.is_us_citizen ? "Yes" : "No") :
                                                "N/A"
                                        }
                                    </span>
                                </div>
                            </div>

                        </div>}
                </div>


            </div>
        </div>
    );
};

export default ShowPatientInformation;
